import { getApm } from 'shared/apm';
import PageApp from 'renderer/PageApp';
import { getRootData, hydrateClient } from 'client/shared/hydrateClient';
import { logger } from 'logger';

export const renderPageClient = () => {
  getApm('full-instrumentation');

  const rootData = getRootData();
  const { content, config } = rootData;
  const { componentData, pageData, preloadedData = {} } = content || {};

  if (!pageData) {
    const error = new Error('Content Renderer: pageData missing for PageApp');

    return logger.error(
      Object.assign(error, {
        logger: 'ContentRenderer | renderPageClient',
        section: 'Hydration Error',
      }),
    );
  }

  return hydrateClient({
    loggerName: 'renderPageClient',
    appElement: (
      <PageApp
        componentLibraryConfig={{
          ...(config || {}),
          cfDomain: config?.cfDomain ?? '',
        }}
        componentData={componentData || []}
        pageData={pageData}
        preloadedData={preloadedData}
      />
    ),
    rootData,
  });
};
